export enum ReferralCategory {
  CARRIER_ELIGIBILITY = 'CARRIER_ELIGIBILITY',
  TRL_DOWNGRADE = 'TRL_DOWNGRADE',
  PRIOR_POLICY_RISK = 'PRIOR_POLICY_RISK',
  MEDICAL = 'MEDICAL',
  OTHER = 'OTHER',
}

export interface ReferralReason {
  id: string;
  category: ReferralCategory;
  title: string;
  body: string;
}

export const DEFAULT_VISIBLE_REASONS = 4;
